export default __webpack_public_path__ + "static/media/JourneyChild.004d2e84.png";